import React, { useContext, useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import ReviewBusinessForm from "../../components/Business/ReviewBusinessForm";
import userService from "../../services/userService";
import { GlobalContext } from "../../utility/GlobalContext";
import axios from "axios";
import { toast } from "react-toastify";
import businessService from "../../services/businessService";
import { useHistory } from "react-router-dom";

export default function CreateAndReviewBusiness(props) {
  const state = props.state;
  const history = useHistory();
  const [newBusiness, setNewBusiness] = useState(null);
  const [name, setName] = useState("");
  const [link, setLink] = useState("");


  function validURL(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(str);
  }

  const createBusiness = async (e) => {
    e.preventDefault();
    if (!name) {
      toast.error("Enter a business name!");
      return;
    }
    if (!link || !validURL(link)) {
      toast.error("Enter a valid link");
      return;
    }
    businessService
      .addBusiness(name, link, state.jwt, true)
      .then((response) => {
        setNewBusiness(response.data.business);
      })
      .catch((err) => {
        toast.error(err.response.data.msg || "Error occurred")
      });
  };

  // const fetchUser = () => {
  //   userService
  //     .fetchSelf(state.jwt)
  //     .then((response) => {
  //       setState({ ...state, user: response.data });
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const forwardToBusiness = () => {
    history.push(`business/${newBusiness.id}`);
  };

  if (!newBusiness) {
    return (
      <div className="col-6">
        <h3>What is the name of the businesss</h3>
        <Form>
          <Form.Group controlId="formName">
            <Form.Label>Business name</Form.Label>
            <Form.Control
              onChange={(e) => setName(e.target.value)}
              type="text"
              placeholder="Enter name"
            />
          </Form.Group>
          <Form.Group controlId="formLink">
            <Form.Label>Business webite URL</Form.Label>
            <Form.Control
              onChange={(e) => setLink(e.target.value)}
              type="text"
              placeholder="Enter URL"
            />
          </Form.Group>

          <Button variant="primary" type="submit" onClick={createBusiness}>
            Submit
          </Button>
        </Form>
      </div>
    );
  }
  return (
    <div>
      {/* <h3>A new review</h3> */}
      {state.user.type === "creator" ? (
        <ReviewBusinessForm
          jwt={state.jwt}
          currentUserID={state.currentUserID}
          business={newBusiness}
          onReviewSucceeded={forwardToBusiness}
        />
      ) : (
        <div>
          <p>Something is wrong</p>
        </div>
      )}
    </div>
  );
}
